module.exports = __webpack_public_path__ + "static/media/cg.8373836c.svg";